// I/O helpers for editor
import { generateJSON as _generateJSON } from "@tiptap/html";
import { readOnlyExtensions } from "$components/editor/shared";
import { prosemirrorToYDoc } from "y-prosemirror";
import { Node } from "@tiptap/pm/model";
import { getSchema, type JSONContent } from "@tiptap/core";

/** Convert generic HTML to our tiptap Doc JSON format
 *
 * Useful for importing HTML content from other sources.
 *
 */
export function generateJSON(html: string) {
  return _generateJSON(html, readOnlyExtensions(false, false, "#FF0000", false, false, false));
}

/** Convert our tiptap Doc JSON to YDoc for use in editing.
 *
 * NOTE: Do not use this to rehydrate a doc that collaboration has already taken place on, otherwise, history will be lost.
 *
 * */
export function generateYDoc(json: JSONContent) {
  // create prosemirror schema from tiptap extensions
  const schema = getSchema(readOnlyExtensions(false, true, "#FF0000", false, false, false));
  // deserialize json to prosemirror node and convert to ydoc
  const doc = Node.fromJSON(schema, json);
  // save to tiptap's "default" xml fragment key
  return prosemirrorToYDoc(doc, "default");
}
